module.exports = __webpack_public_path__ + "static/fishfry-info-1fda29318ea6c37ece320d280bb15e20.png";